import axios from 'axios'

const licences = {
    async getUser(userId: number) {
        return await axios.get(`/users/${userId}`)
    }
}

export default licences
